import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SearchService } from '@df/search/search.service';
import { ElasticsearchService } from './elasticsearch-search.service';

export function provideDfModuleElasticsearch(): EnvironmentProviders {
    return makeEnvironmentProviders([{ provide: SearchService, useClass: ElasticsearchService }]);
}
